import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const ProfilePageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.profile,
      component: React.lazy(() => import('./ProfilePage')),
    },
  ],
};

export default ProfilePageConfig;
